import NumberUtils from 'helpers/numberUtils';
import React from 'react';

const numberUtils = new NumberUtils();

const CoverageSummary = ({ coverages }) => {
  const coverageData = [
    {
      type: 'Auto Liability',
      limit: coverages?.al?.value ?? null,
      carrier: coverages?.al?.carrier,
      status: coverages?.al?.included,
    },
    {
      type: 'Automobile Physical Damage',
      limit: coverages?.apd?.value ?? null,
      carrier: coverages?.apd?.carrier,
      status: coverages?.apd?.included,
    },
    {
      type: 'Motor Truck Cargo',
      limit: coverages?.mtc?.value ?? null,
      carrier: coverages?.mtc?.carrier,
      status: coverages?.mtc?.included,
    },
    {
      type: 'Truckers General Liability',
      limit: coverages?.tgl?.value ?? null,
      carrier: coverages?.tgl?.carrier,
      status: coverages?.tgl?.included,
    },
    {
      type: 'Non-Trucking Liability',
      limit: coverages?.ntl?.value ?? null,
      carrier: coverages?.ntl?.carrier,
      status: coverages?.ntl?.included,
    },
    {
      type: 'Towing Labor and Storage',
      limit: coverages?.towingLaborStorage?.value,
      status: coverages?.towingLaborStorage?.included,
    },
    {
      type: 'UIIA',
      limit: '',
      status: coverages?.UIIAintermodal?.included,
    },
    {
      type: 'Waiver of Subrogation',
      limit: '',
      status: coverages?.waiverSubrogation?.included,
    },
    {
      type: 'Primary and Non-Contributory for AL',
      limit: '',
      status: coverages?.primaryNoncontributoryAL?.included,
    },
    {
      type: 'Primary and Non-Contributory for TGL',
      limit: '',
      status: coverages?.primaryNoncontributoryTGL?.included,
    },
    {
      type: 'Trailer interchange',
      limit: coverages?.trailerInterchange?.limit,
      status: coverages?.trailerInterchange?.included,
    },
    {
      type: 'Refrigeration Coverage',
      limit: '',
      status: coverages?.commoditiesRefrigeration?.included,
    },
  ];

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-bold text-red-500 text-center mb-6">
        Coverage Summary
      </h2>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-[#666666] text-white font-bold">
              <th className="text-left px-4 py-2">Coverage Type</th>
              <th className="text-center px-4 py-2">Carrier</th>
              <th className="text-center px-4 py-2">Limit</th>
              <th className="text-center px-4 py-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {coverageData.map((coverage, index) => (
              <tr
                key={index}
                className="border-b border-gray-100 text-sm"
              >
                <td className="px-4 py-2 text-left">
                  {coverage.type}
                </td>
                <td className="text-center px-4 py-2">
                  {coverage.carrier}
                </td>
                <td className="text-center px-4 py-2">
                  {numberUtils.formatToCurrency(coverage.limit)}
                </td>
                <td
                  className={`text-center px-4 py-2 ${
                    coverage.status ? 'text-gray-500' : 'text-red-600'
                  }`}
                >
                  {coverage.status ? 'Included' : 'Excluded'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-8 space-y-2 text-sm text-gray-600">
        <p className="italic">
          Please note that all deductibles are assigned to a policy by
          Cover Whale. The only way to change deductibles is if the
          insured is required to by contract.
        </p>
        <p className="italic">
          Also note that not all lines of coverage are available for
          each risk or in each state. Please refer to the latest
          product offerings to find available coverages.
        </p>
      </div>
    </div>
  );
};

export default CoverageSummary;
